<template>
  <div class="content">
    <div :class="shadeClass" v-show="shade">
      <img
        v-show="shadeImg"
        class="shadeImg"
        src="@/assets/images/OauthApply/guide.png"
      />
      <div v-show="shadeGif" class="shadeGif">
        <img src="@/assets/images/OauthApply/loading.gif" />
      </div>
    </div>
    <img class="logo" src="@/assets/images/OauthApply/title.png" />
    <div class="button button_ios" @click="toOauthApplyUrl('ios')">
      苹果手机<font class="button_font" v-if="isWx && type != 0">授权并</font
      >打开App
    </div>
    <div class="button button_android" @click="toOauthApplyUrl('android')">
      安卓手机<font class="button_font" v-if="isWx && type != 0">授权并</font
      >打开App
    </div>
    <!-- <wx-open-launch-app
      v-if="isWx"
      class="wx_open_launch_app"
      :appid="mobileAppAppId"
      @error="wxOpenLaunchAppError"
    >
      <script type="text/wxtag-template">
        <style>.wx_open_launch_app_btn {width: 100%; height: 100%; opacity: 0;}</style>
        <button class="wx_open_launch_app_btn"></button>
      </script>
    </wx-open-launch-app> -->
    <div class="text">{{ text }}</div>
  </div>
</template>
<script>
var timer;
export default {
  data() {
    return {
      url: "",
      shade: true,
      shadeGif: true,
      shadeImg: false,
      shadeClass: "shade",
      isWx: false,
      isAndroid: false,
      isIOS: false,
      wxcode: "",
      token: "",
      dmUuid: "",
      type: 0,
      content: "",
      mobileAppAppId: "",
      text: "",
      backgroundImagePath: require("../../assets/images/OauthApply/background.png"),
      logoPath: require("../../assets/images/OauthApply/title.png"),
      shadeImgPath: require("../../assets/images/OauthApply/guide.png"),
      shadeGifPath: require("../../assets/images/OauthApply/loading.gif"),
    };
  },
  created() {
    document.title = "下载应用";
    this.setPhoneSystem();
    this.setParamData();
    /* if (this.isWx) {
      await this.getWxH5JSResDto();
    } */
    if (this.type == 0 || this.isWx == false || this.token) {
      sessionStorage.oauthApplySystem = "";
      this.openApp();
    } else if (this.wxcode != "") {
      this.wxcodeH5Register();
    } else {
      this.shadeHide();
    }
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
  mounted() {
    //处理IOS图片显示问题
    setTimeout(() => {
      $(".content")[0].style.backgroundImage =
        "url('" + this.backgroundImagePath + "')";
      $(".shadeImg")[0].src = this.shadeImgPath;
      $(".shadeGif img")[0].src = this.shadeGifPath;
      $(".logo")[0].src = this.logoPath;
    }, 200);
  },
  methods: {
    //设置页面的手机系统
    setPhoneSystem() {
      let agent = navigator.userAgent.toLowerCase();
      this.isWx = agent.indexOf("micromessenger") != -1; //微信
      this.isAndroid = agent.indexOf("android") != -1; //Android
      this.isIOS = agent.indexOf("iphone") != -1 || agent.indexOf("ipad") != -1; //IOS
    },
    //根据href地址解析参数
    setParamData() {
      let codeArray = window.location.href.split("code=");
      let stateArray;
      //codeArray.length大于1代表微信授权回调
      if (codeArray.length > 1) {
        stateArray = codeArray[1].split("&state=");
        this.wxcode = stateArray[0];
      } else {
        stateArray = codeArray[0].split("&state=");
      }
      if (stateArray.length > 1) {
        let paramArray = stateArray[1].split("#")[0].split("_");
        this.dmUuid = paramArray[0];
        this.type = paramArray[1];
        this.content = paramArray[2];
      }
      this.token = sessionStorage.oauthApplyToken;
    },
    //获取授权申请地址
    toOauthApplyUrl(system, hideConfirm) {
      this.shadeShow();
      //this.isAndroid && system == "ios"
      if (this.isAndroid && system == "ios" && !hideConfirm) {
        this.$confirm(
          "系统检测当前非苹果设备，您确定仍跳转苹果应用市场吗？",
          "提示",
          {
            confirmButtonText: "继续跳转",
            cancelButtonText: "取消",
            type: "warning",
            showClose: false,
          }
        )
          .then(() => {
            this.toOauthApplyUrl(system, true);
          })
          .catch(() => {
            this.shadeHide();
          });
        return;
      }
      sessionStorage.oauthApplySystem = system;
      if (this.type == 0 || this.isWx == false || this.token) {
        this.openApp();
        return;
      }
      let testRequest = new Request(
        this.url + "/mobile/login/getOauthApplyUrl",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.dmUuid + "_" + this.type + "_" + this.content,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.shadeHide();
            location.replace(res.data);
          } else {
            console.log("其他错误");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //微信H5注册登录
    wxcodeH5Register() {
      this.shadeShow();
      let testRequest = new Request(
        this.url + "/mobile/login/wxcodeH5Register",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: {
              code: this.wxcode,
            },
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.token = res.data.token;
            sessionStorage.oauthApplyToken = this.token;
            this.addOauthApply();
          } else if (res.status == 1051) {
            console.log("微信code获取openid失败");
          } else {
            console.log("其他错误");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //添加授权申请
    addOauthApply() {
      this.shadeShow();
      let data = {};
      data = {
        dmUuid: this.dmUuid,
        type: this.type,
        content: this.content,
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
        takerToken: this.token,
      };
      let request = new Request(this.url + "/mobile/bygUser/addOauthApply", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify({
          data: data,
        }),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.openApp();
            console.log("添加成功");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    openApp() {
      this.shadeShow();
      let system = sessionStorage.oauthApplySystem;
      if (system == undefined || system == "") {
        if (this.isAndroid) {
          system = "android";
        } else if (this.isIOS) {
          system = "ios";
        }
      }
      //this.shadeAndroidShow();
      //return;
      if (system == "android") {
        if (this.isWx) {
          this.shadeAndroidShow();
        } else {
          timer = setTimeout(() => {
            this.shadeHide();
            location.replace(this.url + "/common/downloadApk/" + system);
          }, 2000);
          this.schemeUrl();
        }
      } else if (system == "ios") {
        /* timer = setTimeout(() => {
          this.shadeHide();
          location.replace("https://apps.apple.com/cn/app/id1439521846");
        }, 2000);
        this.schemeUrl(); */
        this.shadeHide();
        location.replace(this.url + "/common/downloadApk/" + system);
        //location.replace("https://apps.apple.com/cn/app/id6446279565");
      } else {
        this.shadeHide();
      }
    },
    schemeUrl() {
      window.location.href = "zhongguangjiashu://";
      document.removeEventListener(
        "visibilitychange",
        this.schemeUrlClearTimeout
      );
      document.addEventListener("visibilitychange", this.schemeUrlClearTimeout);
    },
    schemeUrlClearTimeout() {
      if (document.hidden) {
        this.shadeHide();
        clearTimeout(timer);
      }
    },
    shadeShow() {
      this.shade = true;
      this.shadeGif = true;
    },
    shadeHide() {
      this.shade = false;
      this.shadeGif = false;
    },
    shadeAndroidShow() {
      this.shadeClass = "shade shadeAndroid";
      this.shade = true;
      this.shadeGif = false;
      this.shadeImg = true;
    },
    /* //获取微信JS授权信息
    async getWxH5JSResDto() {
      let testRequest = new Request(this.url + "/common/getWxH5JSResDto", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
        },
        body: JSON.stringify({
          data: window.location.href.split("#")[0],
        }),
      });
      await fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.setWxConfig(res.data);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setWxConfig(data) {
      this.mobileAppAppId = data.mobileAppAppId;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ["checkJsApi"], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      });
    }, */
  },
};
</script>

<style lang="stylus" scoped>
.content {
  display: flex;
  flex-direction: column;
  background-image: url('../../assets/images/OauthApply/background.png');
  background-size: 100% 100%;
  background-attachment: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.shade {
  z-index: 99;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-attachment: fixed;
}

.shadeGif {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  margin: 260px auto 0;
  width: 40px;
  height: 40px;
}

.shadeGif img {
  width: 32px;
  height: 32px;
  padding: 4px;
}

.shadeAndroid {
  background: #000000;
  opacity: 0.6;
}

.shadeImg {
  position: absolute;
  top: 4px;
  right: 30px;
  width: 266px;
  height: 104px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.logo {
  position: absolute;
  top: 111px;
  left: 50%;
  margin-left: -64px;
  width: 128px;
  height: 128px;
}

.button {
  position: absolute;
  left: 50%;
  margin-left: -135px;
  width: 270px;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 8px 21px 2px rgba(233, 233, 233, 0.7);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}

.button_font {
  display: contents;
}

.button_ios {
  top: 285px;
}

.button_android {
  top: 365px;
}

.text {
  word-break: break-all;
  position: absolute;
  bottom: 0px;
}
</style>
<style>
.el-message-box {
  width: 340px !important;
  margin-top: -100px;
}
.el-message-box__message {
  font-size: 16px !important;
}
.el-button--mini,
.el-button--small {
  font-size: 14px !important;
}
.wx_open_launch_app {
  position: absolute;
  z-index: 1;
  top: 365px;
  width: 270px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/OauthApply/OauthApply.vue